// Floating Reviews Tab - Customer Reviews Screenshots

(function() {
  'use strict';
  
  // إعدادات
  const CONFIG = {
    tabText: 'Reviews',
    position: 'right',
  };
  
  // صور المراجعات - الصور الجديدة
  const REVIEW_IMAGES = [
    {
      id: 1,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.17_AM_2.jpg?v=1764113155',
      alt: 'Customer Review 1'
    },
    {
      id: 2,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM_2.jpg?v=1764113154',
      alt: 'Customer Review 2'
    },
    {
      id: 3,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.15_AM_2.jpg?v=1764113154',
      alt: 'Customer Review 3'
    },
    {
      id: 4,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.14_AM_2.jpg?v=1764113154',
      alt: 'Customer Review 4'
    },
    {
      id: 5,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM_5.jpg?v=1764113153',
      alt: 'Customer Review 5'
    },
    {
      id: 6,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.15_AM_1.jpg?v=1764113153',
      alt: 'Customer Review 6'
    },
    {
      id: 7,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.14_AM.jpg?v=1764113153',
      alt: 'Customer Review 7'
    },
    {
      id: 8,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.14_AM_1.jpg?v=1764113150',
      alt: 'Customer Review 8'
    },
    {
      id: 9,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.15_AM_3.jpg?v=1764113153',
      alt: 'Customer Review 9'
    },
    {
      id: 10,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.17_AM.jpg?v=1764113153',
      alt: 'Customer Review 10'
    },
    {
      id: 11,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM_3.jpg?v=1764113153',
      alt: 'Customer Review 11'
    },
    {
      id: 12,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.17_AM_1.jpg?v=1764113153',
      alt: 'Customer Review 12'
    },
    {
      id: 13,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM_1.jpg?v=1764113153',
      alt: 'Customer Review 13'
    },
    {
      id: 14,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM.jpg?v=1764113153',
      alt: 'Customer Review 14'
    },
    {
      id: 15,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.15_AM_4.jpg?v=1764113153',
      alt: 'Customer Review 15'
    },
    {
      id: 16,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.15_AM.jpg?v=1764113153',
      alt: 'Customer Review 16'
    },
    {
      id: 17,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0947/4958/9801/files/WhatsApp_Image_2025-11-26_at_1.22.16_AM_4.jpg?v=1764113153',
      alt: 'Customer Review 17'
    }
  ];
  
  // إنشاء HTML للزرار الجانبي
  function createFloatingTab() {
    const button = document.createElement('button');
    button.className = 'floating-reviews-tab';
    button.innerHTML = `
      ${CONFIG.tabText}
      <span class="rating">★★★★★</span>
    `;
    button.addEventListener('click', openReviewsPopup);
    return button;
  }
  
  // إنشاء HTML للنافذة المنبثقة
  function createPopup() {
    const overlay = document.createElement('div');
    overlay.className = 'reviews-popup-overlay';
    overlay.innerHTML = `
      <div class="reviews-popup">
        <div class="reviews-popup-header">
         <button class="reviews-popup-close" aria-label="Close">&times;</button>
         <h2>Customer Reviews</h2> 
        </div>
        <div class="reviews-popup-content">
          ${createReviewImagesHTML()}
        </div>
      </div>
    `;
    
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('reviews-popup-close')) {
        closeReviewsPopup();
      }
    });
    
    return overlay;
  }
  
  // إنشاء HTML لعرض الصور
  function createReviewImagesHTML() {
    if (REVIEW_IMAGES.length === 0) {
      return `
        <div class="no-reviews">
          <h3>No reviews yet</h3>
          <p>Be the first to share your feedback!</p>
        </div>
      `;
    }
    
    return `
      <div class="reviews-images-grid">
        ${REVIEW_IMAGES.map(review => `
          <div class="review-image-wrapper">
            <img 
              src="${review.imageUrl}" 
              alt="${review.alt}"
              class="review-image"
              loading="lazy"
            />
          </div>
        `).join('')}
      </div>
    `;
  }
  
  // فتح النافذة المنبثقة
  function openReviewsPopup() {
    const overlay = document.querySelector('.reviews-popup-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  
  // إغلاق النافذة المنبثقة
  function closeReviewsPopup() {
    const overlay = document.querySelector('.reviews-popup-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  // تهيئة الـ Widget
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    // إضافة الزرار الجانبي
    const floatingTab = createFloatingTab();
    document.body.appendChild(floatingTab);
    
    // إضافة النافذة المنبثقة
    const popup = createPopup();
    document.body.appendChild(popup);
    
    // إغلاق بزر Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeReviewsPopup();
      }
    });
  }
  
  // بدء التنفيذ
  init();
})();